import React from 'react'
import { MDBRow, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText ,MDBCol, MDBCardImage, MDBContainer} from 'mdbreact'

export default function productDetails() {
    return (
        <div>
 <section  
 style={{
     backgroundImage:"url(https://images.pexels.com/photos/2064357/pexels-photo-2064357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)"
 }}>
 
 <MDBContainer className="p-5">
     <br  />
 <MDBRow className="pt-5">
 <br  />
     <MDBCol md="12" className="pt-3">
     <h1 class="mb-4">our <span class="text-danger">the best rated</span>
   <span class="cyan-text">Milk Products</span> near you.</h1>
<p class="mb-4 pb-2 dark-grey-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam vitae, culpa qui officia deserunt laborum fuga similique mollit id quos aperiam proident non ut rerum debitis.</p>
  <button type="button" class="btn btn-primary btn-rounded btn-md ml-md-0">Get started</button>

     </MDBCol>
    
 </MDBRow>

 </MDBContainer>


</section>
<section>
             <MDBContainer className="my-5 ml-2">
             <MDBRow>
                    <MDBCol md="4">
                        <center>
                            <img
                            src="http://www.visakhadairy.com/images/p3.jpg"
                            />
                        </center>
                    </MDBCol>
                    <MDBCol className="m-5">
                      <h1>Pasteurised Full Cream Milk&nbsp;<span class="badge badge-primary">New</span></h1>
                      <h2>Description</h2>
                     
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.
                           Et dolor suscipit libero eos atque quia ipsa sint voluptatibus!
                            Beatae sit assumenda asperiores iure at maxime atque repellendus
                             maiores quia sapiente.</p>
                             <div class="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">

        
<div class="card">


  <div class="card-header" role="tab" id="headingOne1">
    <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1" aria-expanded="true"
      aria-controls="collapseOne1">
      <h5 class="mb-0">
        Description
        <i class="fas fa-angle-down rotate-icon"></i>
      </h5>
    </a>
  </div>

 
  <div id="collapseOne1" class="collapse show" role="tabpanel" aria-labelledby="headingOne1"
    data-parent="#accordionEx">
    <div class="card-body">
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
      3 wolf moon officia aute,
      non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf
      moon
      tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
    </div>
  </div>
</div>



<div class="card">


  <div class="card-header" role="tab" id="headingTwo2">
    <a class="collapsed" data-toggle="collapse" data-parent="#accordionEx" href="#collapseTwo2"
      aria-expanded="false" aria-controls="collapseTwo2">
      <h5 class="mb-0">
        Details
        <i class="fas fa-angle-down rotate-icon"></i>
      </h5>
    </a>
  </div>


  <div id="collapseTwo2" class="collapse" role="tabpanel" aria-labelledby="headingTwo2"
    data-parent="#accordionEx">
    <div class="card-body">
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
      3 wolf moon officia aute,
      non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf
      moon
      tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
    </div>
  </div>
</div>


<div class="card">


  <div class="card-header" role="tab" id="headingThree3">
    <a class="collapsed" data-toggle="collapse" data-parent="#accordionEx" href="#collapseThree3"
      aria-expanded="false" aria-controls="collapseThree3">
      <h5 class="mb-0">
        Shipping
        <i class="fas fa-angle-down rotate-icon"></i>
      </h5>
    </a>
  </div>


  <div id="collapseThree3" class="collapse" role="tabpanel" aria-labelledby="headingThree3"
    data-parent="#accordionEx">
    <div class="card-body">
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
      3 wolf moon officia aute,
      non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf
      moon
      tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
    </div>
  </div>
</div>


</div>


                    </MDBCol>
                 </MDBRow>
             </MDBContainer>
         </section>
       
        </div>
    )
}
